export default "__VITE_ASSET__CIk0$R3T__"